import React from "react";

const WhatWeDo = () => {
  return (
    <div className="sis-what-we-do-section sis-comman-bg mt-3 sis-br-radius section">
      <div className="container">

        {/* =========================================
            SECTION TITLE
        ========================================== */}
        <div className="row">
          <div className="col-12">

            <div className="sisf-sis-section-title text-center sis-section-title">

              <span className="sisf-m-subtitle sis-text-anime-style-3">
                WHAT WE DO
              </span>

              <h2 className="sisf-m-title sis-text-anime-style-3">
                Reliable Cab Services for Local,
                <br />
                Airport, Corporate &amp; Outstation Travel
              </h2>

              <div
                className="sisf-m-text"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                <p>
                  CitySky Cabs provides comfortable and convenient cab rental
                  services in Pune with multiple vehicle options, professional
                  drivers and easy booking assistance
                  <br />
                  for local journeys, airport transfers, corporate travel,
                  family tours and outstation trips.
                </p>
              </div>

            </div>

          </div>
        </div>


        {/* =========================================
            MAIN CONTENT
        ========================================== */}
        <div className="row">

          <div className="col-lg-8">

            <div className="row">

              {/* =====================================
                  CAB RENTAL SOLUTIONS
              ====================================== */}
              <div className="col-md-6 pe-2">

                <div
                  className="sisf-e-what-we-do-content sis-comman-background sis-radius mb-3"
                  data-aos="fade-up"
                  data-aos-delay="100"
                >

                  <div className="sisf-e-inner p-4">

                    <div className="sis-icon-with-title d-flex align-items-center gap-4">

                      <div className="sisf-what-we-do-icon-image">

                        <figure>
                          <img
                            src="/images/what-we-do-icon.svg"
                            alt="CitySky Cabs Cab Rental Services"
                          />
                        </figure>

                      </div>


                      <div className="sisf-sis-e-title">

                        <h3 className="sisf-e-title text-white">
                          <span>
                            Complete Cab Rental Solutions
                          </span>
                        </h3>

                      </div>

                    </div>


                    {/* CONTENT */}
                    <div className="sisf-e-content mt-3">

                      <div className="sisf-e-text">

                        <p className="text-white">
                          Choose CitySky Cabs for convenient transportation
                          solutions for Pune local travel, airport transfers,
                          corporate requirements, outstation journeys and
                          family trips.
                        </p>

                      </div>

                    </div>


                    {/* =================================
                        SERVICE LISTING
                    ================================== */}
                    <div className="sisf-sis-listing-items">

                      <p className="mb-2">

                        <span className="text-white">
                          <i className="fa-solid pe-3 fa-check"></i>
                        </span>

                        <span className="text-white">
                          Local &amp; Pune city cab services
                        </span>

                      </p>


                      <p className="mb-2">

                        <span className="text-white">
                          <i className="fa-solid pe-3 fa-check"></i>
                        </span>

                        <span className="text-white">
                          Airport pickup &amp; drop services
                        </span>

                      </p>


                      <p className="mb-2">

                        <span className="text-white">
                          <i className="fa-solid pe-3 fa-check"></i>
                        </span>

                        <span className="text-white">
                          Corporate &amp; business transportation
                        </span>

                      </p>


                      <p className="mb-0">

                        <span className="text-white">
                          <i className="fa-solid pe-3 fa-check"></i>
                        </span>

                        <span className="text-white">
                          Outstation, family &amp; group travel
                        </span>

                      </p>

                    </div>

                  </div>

                </div>

              </div>


              {/* =====================================
                  SERVICE LOCATIONS
              ====================================== */}
              <div className="col-md-6 ps-2">

                <div
                  className="sisf-e-what-we-do-content bg-white sis-radius overflow-hidden mb-3"
                  data-aos="fade-up"
                  data-aos-delay="300"
                >

                  <div className="sisf-e-inner">

                    <div className="sisf-content-top pt-4 px-4">

                      <div className="sisf-sis-e-title mb-2">

                        <h3 className="sisf-e-title">
                          <span>
                            Cab Service Across Pune
                          </span>
                        </h3>

                      </div>


                      <div className="sisf-e-text">

                        <p className="mb-0">
                          CitySky Cabs serves customers across Pune and
                          Pimpri-Chinchwad with convenient pickup options for
                          local journeys, airport transfers, corporate travel
                          and outstation trips.
                        </p>

                      </div>

                    </div>


                    {/* MAP IMAGE */}
                    <div className="sisf-image-bottom-map">

                      <figure>
                        <img
                          src="/images/map.jpg"
                          alt="CitySky Cabs Service Locations in Pune"
                        />
                      </figure>

                    </div>

                  </div>

                </div>

              </div>


              {/* =====================================
                  BOTTOM IMAGE
              ====================================== */}
              <div className="col-md-7 pe-2">

                <div className="sisf-what-we-do-image-bottom">

                  <figure className="sis-image-anime sis-reveal">

                    <img
                      src="/images/what-we-do-image1.png"
                      className="w-100 sis-radius"
                      alt="CitySky Cabs Outstation Cab Service Pune"
                    />

                  </figure>

                </div>

              </div>


              {/* =====================================
                  BOOKING ASSISTANCE
              ====================================== */}
              <div className="col-md-5 ps-2">

                <div
                  className="sisf-e-what-we-do-content sis-comman-background sis-radius"
                  data-aos="fade-up"
                  data-aos-delay="100"
                >

                  <div className="sisf-e-inner p-4">

                    <div className="sis-counter-item">

                      <div className="sis-what-we-do-icon-image mb-4">

                        <figure>
                          <img
                            src="/images/what-we-do-icon1.svg"
                            alt="CitySky Cabs Booking Assistance"
                          />
                        </figure>

                      </div>


                      {/* 24/7 */}
                      <div className="sis-counter-title mb-3">

                        <h2 className="d-flex align-items-center">

                          <span className="sis-counter text-white">
                            24
                          </span>

                          <span className="sisf-digit-label text-white">
                            {" × 7"}
                          </span>

                        </h2>

                      </div>


                      <div className="sis-counter-content">

                        <span className="sisf-content text-white">
                          Cab Booking Assistance
                        </span>

                      </div>

                    </div>


                    {/* BUTTON */}
                    <div className="sisf-m-button mt-3 pt-4">

                      <a
                        href="/enquiry"
                        className="sis-btn-default btn-light"
                      >
                        Book Your Cab

                        <i className="fa-solid fa-arrow-right-long"></i>
                      </a>

                    </div>

                  </div>

                </div>

              </div>

            </div>

          </div>


          {/* =========================================
              RIGHT IMAGE
          ========================================== */}
          <div className="col-lg-4 ps-0">

            <div className="sisf-what-we-do-image-right">

              <figure className="sis-image-anime sis-reveal">

                <img
                  src="/images/what-we-do-image2.png"
                  className="w-100 sis-radius"
                  alt="CitySky Cabs Cab Service in Pune"
                />

              </figure>

            </div>

          </div>

        </div>


        {/* =========================================
            BOTTOM CTA
        ========================================== */}
        <div className="row">

          <div className="col-12">

            <div className="sis-comman-bottom-line-text d-flex align-items-center justify-content-center gap-3">

              <div
                className="sisf-users-image"
                data-aos="fade-up"
                data-aos-delay="100"
              >

                <figure>
                  <img
                    src="/images/users2.png"
                    alt="CitySky Cabs Customers"
                  />
                </figure>

              </div>


              <div
                className="sisf-sis-e-box d-flex align-items-center justify-content-center"
                data-aos="fade-up"
                data-aos-delay="300"
              >

                <p className="mb-0">
                  Planning your next journey with CitySky Cabs?{" "}

                  <a href="/enquiry">
                    Get Your Cab Quote.
                  </a>
                </p>

              </div>

            </div>

          </div>

        </div>

      </div>
    </div>
  );
};

export default WhatWeDo;